import React from 'react';
import classNames from 'classnames';
import { types as sdkTypes } from '../../../util/sdkLoader';
import { formatMoney } from '../../../util/currency';
import { FieldCheckbox, FieldTextInput } from '../../../components';
import { FormattedMessage } from '../../../util/reactIntl';
import { daysBetween } from '../../../util/dates';

import css from './Attachments.module.css';

const { Money } = sdkTypes;

const formatInputValue = value => (!!value ? value.replace(/[^\d.]/g, '') : '');

const calculatePrice = ({
  days,
  priceMonthlyPerDay,
  pricePerDay,
  priceWeeklyPerDay
}) => {

  if (days >= 1 && days <= 4) {
    return {
      amount: days * pricePerDay.amount,
      currency: pricePerDay.currency,
    }
  } else if (days >= 5 && days <= 19) {
    return {
      amount: days * priceWeeklyPerDay.amount,
      currency: priceWeeklyPerDay.currency,
    }
  } else if (days >= 20) {
    return {
      amount: days * priceMonthlyPerDay.amount,
      currency: priceMonthlyPerDay.currency,
    }
  }
}

const Attachments = ({ listing = {}, values = {}, formApi, intl }) => {
  const {
    freeAttachments = [],
    paidAttachments = [],
    unitType,
  } = listing.attributes?.publicData ?? {};
  const {
    bookingDates,
    quantity,
  } = values;
  const isSale = unitType === 'item';
  const totalAttachments = freeAttachments.concat(paidAttachments);
  const showAttachments = ((bookingDates && quantity) || isSale) && totalAttachments.length;

  const handleClick = (e, key, keyQuantity) => {
    e.persist();
    e.stopPropagation();
    e.preventDefault();

    if (
      e.target.id === key ||
      e.target.id === keyQuantity
    ) return;

    const value = values[key]?.includes(key) ? [] : [key];
    formApi.change(key, value);
  }

  const days = bookingDates ? daysBetween(bookingDates.startDate, bookingDates.endDate) : 0;

  return showAttachments ? (
    <div className={css.root}>
      <h2 className={css.title}>
        <FormattedMessage id="BookingDatesForm.attachmentsHeadline" />
      </h2>
      <p className={css.description}>
        <FormattedMessage id="BookingDatesForm.attachmentsDescription" />
      </p>

      <div>
        {totalAttachments.map(({
          freeTypeAttachment,
          isPricing,
          paidTypeAttachment,
          priceMonthlyPerDay,
          pricePerDay,
          priceWeeklyPerDay,
          id,
         }) => {
          const isPaid = typeof isPricing !== "undefined";
          const label = isPaid ? paidTypeAttachment : freeTypeAttachment;
          const key = id;
          const quantityFieldKey = `${key}_quantity`;

          const clsSelected = classNames(css.attachmentOption, {
            [css.selected]: key === (values[key] && values[key][0]),
          });

          const resultPrice = isPaid && isPricing && days
            ? calculatePrice({ days, priceMonthlyPerDay, pricePerDay, priceWeeklyPerDay })
            : null;

          return (
            <div key={key} className={clsSelected} onClick={(e) => handleClick(e, key, quantityFieldKey)}>
              <div className={css.checkboxWrapper}>
                <FieldCheckbox
                  id={key}
                  name={key}
                  value={key}
                  useSuccessColor
                />
              </div>
              <div>
                <span className={css.attachmentLabel}>{label}</span>
                <div className={css.attachmentValueWrapper}>
                  <span className={css.attachmentValue}>
                    {isPaid && isPricing && days
                      ? formatMoney(intl, new Money(resultPrice.amount, resultPrice.currency))
                      : <FormattedMessage
                          id={`BookingDatesForm.${isPaid && !isPricing ? "rfq" : "includedAttachment"}`}
                        />
                    }
                  </span>
                  {isPaid && ((isPricing && days) || !isPricing) ?
                    (
                      <>
                        <span className={css.multipleSymbol}>x</span>
                        <FieldTextInput
                          format={formatInputValue}
                          parse={formatInputValue}
                          className={css.field}
                          key={quantityFieldKey}
                          id={quantityFieldKey}
                          name={quantityFieldKey}
                          type="text"
                          placeholder={intl.formatMessage({ id: "BookingDatesForm.quantityCount" })}
                        />
                        <span className={css.quantity}>
                          <FormattedMessage id="BookingDatesForm.attachmentQuantity" />
                        </span>
                      </>
                    ) : null}
                  </div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  ) : null;
}

export default Attachments;
